import { Users, Trophy, ClipboardText, Sparkle, ChartBar } from '@phosphor-icons/react';

export const AdminStatCard = ({ icon: Icon, label, value, onClick, color = 'gray', testId }) => (
  <button
    onClick={onClick}
    className="bg-white border border-gray-200 hover:border-[#F97316] rounded-2xl p-5 text-left transition-all card-lift w-full"
    data-testid={testId}
  >
    <div className={`w-10 h-10 rounded-lg bg-${color}-50 flex items-center justify-center mb-3`}>
      <Icon size={20} weight="bold" className={`text-${color}-600`} />
    </div>
    <div className="text-2xl sm:text-3xl font-bold text-gray-900">{value}</div>
    <div className="text-xs text-gray-500 uppercase font-semibold mt-1">{label}</div>
  </button>
);

export const AdminTabBtn = ({ id, label, icon: Icon, active, onClick }) => (
  <button
    onClick={onClick}
    className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold transition-all whitespace-nowrap ${
      active ? 'bg-gray-900 text-white' : 'bg-white border border-gray-200 text-gray-700 hover:border-gray-400'
    }`}
    data-testid={`tab-${id}-btn`}
  >
    <Icon size={16} weight="bold" /> {label}
  </button>
);

export const TAB_ICONS = { overview: ChartBar, users: Users, tournaments: Trophy, registrations: ClipboardText, pending: Sparkle };

export const statusBadgeClass = (s) => {
  const map = {
    pending_approval: 'bg-orange-50 text-orange-700 border-orange-200',
    approved: 'bg-green-50 text-green-700 border-green-200',
    rejected: 'bg-red-50 text-red-700 border-red-200',
    deletion_requested: 'bg-red-50 text-red-700 border-red-200',
    archived: 'bg-gray-100 text-gray-600 border-gray-200',
    pending_verification: 'bg-orange-50 text-orange-700 border-orange-200',
    form_submitted: 'bg-orange-50 text-orange-700 border-orange-200'
  };
  return map[s] || 'bg-gray-50 text-gray-700 border-gray-200';
};

export const statusLabel = (s) => ({
  pending_approval: 'Pending Approval',
  approved: 'Approved',
  rejected: 'Rejected',
  pending_verification: 'Pending Verification',
  form_submitted: 'Pending Verification'
}[s] || (s || '').replace('_', ' '));

export const roleBadgeClass = (role) => {
  if (role === 'admin') return 'bg-purple-50 text-purple-700';
  if (role === 'organizer') return 'bg-gray-900 text-white';
  return 'bg-orange-50 text-orange-700';
};
